export const seoRouteData = {
  accountAction: {
    title: 'Account Action | Helpline Software',
    description: 'Processing your account request. You will be redirected to reset your password or verify your email.',
  },
  callLogs: {
    title: 'Call Logs | Helpline Software',
    description:
      "Search and filter your helpline's call and conversation history by date, and review the details of every contact.",
  },
  chat: {
    title: 'Chat & Text | Helpline Software',
    description:
      "Answer and review your helpline's chat and text conversations in one secure place with searchable conversation logs.",
  },
  contactCenter: {
    title: 'Contact Center | Helpline Software',
    description:
      'Your live call workspace: view caller details, complete documentation forms, and switch between active conversations.',
  },
  createShift: {
    title: 'Create Shift | Helpline Software',
    description:
      "Add a new shift to your helpline's on-call schedule with start and end times and a live preview of calendar coverage.",
  },
  editShift: {
    title: 'Edit Shift | Helpline Software',
    description:
      "Update an existing shift on your helpline's on-call schedule and preview coverage changes before saving.",
  },
  eventRequests: {
    title: 'Shift Requests | Helpline Software',
    description:
      "Review, approve, and manage advocate shift requests to keep your helpline's on-call schedule fully covered.",
  },
  eventsCalendar: {
    title: 'Request Shifts | Helpline Software',
    description:
      "Browse your helpline's on-call calendar, select open shifts, and submit shift requests in a few clicks.",
  },
  forgotPassword: {
    title: 'Forgot Password | Helpline Software',
    description:
      'Enter your email to receive a secure password reset link and regain access to your Helpline Software account.',
  },
  inbox: {
    title: 'Voicemail Inbox | Helpline Software',
    description:
      'Listen to voicemails, handle callback requests and pages, and return calls from one inbox so no caller is missed.',
  },
  incomingChat: {
    title: 'Chat With an Advocate | Helpline Software',
    description:
      'Start a secure, anonymous chat with a trained advocate. Your conversation is private and you can leave quickly at any time.',
  },
  login: {
    title: 'Log In | Helpline Software',
    description:
      'Log in to Helpline Software to manage on-call schedules, answer calls and chats, and run your crisis or support line.',
  },
  modifySchedule: {
    title: 'Modify Schedule | Helpline Software',
    description:
      "Edit your helpline's on-call calendar: create, split, or delete shifts and make bulk changes to keep coverage accurate.",
  },
  orgSelectAndEdit: {
    title: 'Manage Organizations | Helpline Software',
    description:
      'Super admin tools for creating and configuring organizations: phone numbers, IVRs, call lists, chat, and email templates.',
  },
  orgSettings: {
    title: 'Organization Settings | Helpline Software',
    description:
      "Configure your organization's communication workflows, chat and text settings, forms, and team-wide preferences.",
  },
  resetPassword: {
    title: 'Reset Password | Helpline Software',
    description:
      'Choose a new password for your Helpline Software account to securely regain access to your helpline tools.',
  },
  resetPasswordError: {
    title: 'Reset Link Expired | Helpline Software',
    description:
      'This password reset link is invalid or expired. Request a fresh link to restore access to your Helpline Software account.',
  },
  serviceExceptions: {
    title: 'Service Exceptions | Helpline Software',
    description:
      "Schedule temporary overrides like holiday hours or closures so your helpline's call routing always matches reality.",
  },
  stats: {
    title: 'Analytics | Helpline Software',
    description:
      'Track helpline performance with dashboards for call volume, shift hours, burnout prevention, usage, and reports.',
  },
  support: {
    title: 'Support | Helpline Software',
    description:
      'Get help with Helpline Software: contact our support team or browse the help center for guides and answers.',
  },
  userProfile: {
    title: 'My Profile | Helpline Software',
    description:
      'Manage your advocate profile, track your hours and calls, view confirmed shifts, and set up SMS shift reminders.',
  },
  users: {
    title: 'User Management | Helpline Software',
    description: 'Add, edit, and remove advocates and admins, and manage roles and permissions for your helpline team.',
  },
  verifyEmail: {
    title: 'Verify Email | Helpline Software',
    description:
      'Confirm your email address to keep your Helpline Software account and notification settings up to date.',
  },
};
